import { fetchFromObject } from 'helpers/object';

export default {
  data: state => field => fetchFromObject(state, field),
  getFieldFromListByValue: (state, getters) => (nameList, value, returnField = 'label') => {
    const list = getters.data(nameList);
    return list.find(element => element.value === value)[returnField];
  },
  hasMasterData: state =>
    !!state.streetType &&
    !!state.maritalStatus &&
    !!state.profession &&
    !!state.sex &&
    !!state.signType,

  hasCheckinoutMasterData: state => state.checkinoutMasterData?.length
};
